import { Component, OnInit } from '@angular/core';
// import {} from 'googlemaps'
import { environment } from 'src/environments/environment-taxi-directo';
import { VersionCheckService } from './service/version-check.service';
import * as PackageJson from '../../package.json';
import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2'
import { ConfiguracionParametrosService } from './service/configuracion-parametros.service';
import { CookieConsentService } from './service/cookie-consent.service';
import { WebSocketService } from './service/web-socket.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private versionCheckService: VersionCheckService,
    private cookieService: CookieService,
    private ParametroService: ConfiguracionParametrosService,
    public cookieConsentService: CookieConsentService,
    private webSocketService: WebSocketService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    environment.VERSION = PackageJson.version;
    this.versionCheckService.initVersionCheck(environment.versionCheckURL)
    //this.REFRESCAR();
    //this.CheckUpdates();
    this.redireccionar();
    this.webSocketService.connect();
    this.webSocketService.receiveUpdate().subscribe((data: any) => {
      Swal.fire({
        title: "¡Actualización disponible!",
        text: "Hay una nueva versión de la web disponible.",
        icon: "info",
        confirmButtonText: `Actualizar`,
        allowOutsideClick: false
      }).then((result) => {
        this.router.navigate(['']);
        window.localStorage.clear();
        document.location.reload();
      });
    });
  }

  REFRESCAR() {
    console.log('version', environment.VERSION);
   //var version= this.cookieService.get('version')
    if (localStorage.getItem('version')) {
      var version= localStorage.getItem('version')
      this.cookieService.delete('version')
      this.cookieService.delete('VERSION')
      localStorage.setItem('version', environment.VERSION)
      if(environment.VERSION !=version){
        Swal.fire({
          position: 'top',
          title: 'Nueva Versión Disponible',
          confirmButtonText: `Actualizar`
        }).then((result) => {
          if (result.isConfirmed) {
            var version= this.cookieService.get('version')
            localStorage['refreshed'] = true;
            window.localStorage.clear();
            document.location.reload()
            
          }
        })
      }
      
    } else {
      localStorage.setItem('version', environment.VERSION)
    }
  }

  CheckUpdates(){
    this.ParametroService.getParameter('VERSION_WEB_INTRANET').subscribe( (data: any) => {
      if(data.valor){
        if(environment.VERSION != data.valor){
          if (typeof (window as any).forceReload === 'function') {
            Swal.fire({
              position: 'top',
              title: '¡Nueva Versión Disponible!',
              confirmButtonText: `Actualizar`
            }).then((result) => {
              if (result.isConfirmed) {
                (window as any).forceReload();
              }
            })
            
          } else {
              console.error("La función 'forceReload' no está definida en el script.");
          }
        }else{
          console.log("Environment version: ", environment.VERSION);
          console.log("BD Version: ", data.valor);
        }
      }
    })
  }

  redireccionar(){
    var urlActual: string = window.location.href;
    //console.log(urlActual);

    if(urlActual.includes("directo.nexusvirtual.net")){
      var newUrl = urlActual.replace("directo.nexusvirtual.net","portal.directoapp.pe")
      console.log("redireccionando...");
      window.location.href = newUrl;
    }
  }

}